import DefaultCell from "application/components/DefaultCell";
import CTLDownloadFile from "application/components/CTLDownloadFile";
import PAPlayAudio from "application/components/PAPlayAudio";
import CTLUnReadCell from "application/components/CTLUnReadCell";
import SessionData from "./sessionData";

const operationURLS = {
  list: "customerCDR/callerCall/list",
  pdfDownload: "customerCDR/generateAndDownloadPdf",
  csvDownload: "customerCDR/callerCall/downloadCSV",
  csvFilter: "customerCDR/callerCall/downloadCSV1",
};

const getColumns = () => {
  return [
    {
      Header: "Queue Id",
      accessor: "queue",
      displayInList: true,
      allowFilter: true,
      dataType: "string",
      allowReportColumn: true,
      allowReportFilter: true,
      Cell: ({ value }) => <DefaultCell value={value} />,
      controlType: "multipleSelect",
      options: {
        keyField: "queue",
        keyDescription: "queueName",
        values: [],
        url: "customerCDR/queues",
      },
    },
    {
      Header: "Queue Name",
      accessor: "queueName",
      displayInList: true,
      allowFilter: false,
      dataType: "string",
      allowReportColumn: true,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Agent ID",
      accessor: "ccAgent",
      displayInList: true,
      allowFilter: true,
      dataType: "string",
      Cell: ({ value }) => <DefaultCell value={value} />,
      controlType: "multipleSelect",
      allowReportColumn: true,
      allowReportFilter: true,
      options: {
        keyField: "ccAgent",
        keyDescription: "agentFullName",
        values: [],
        url: "/customerCDR/agents",
      },
    },
    {
      Header: "Agent Name",
      accessor: "agentFullName",
      displayInList: true,
      allowFilter: false,
      dataType: "string",
      allowReportColumn: true,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
   
    {
      Header: "Campaign Name",
      accessor: "campaign",
      displayInList: true,
      allowFilter: false,
      dataType: "string",
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Direction",
      accessor: "callDirection",
      displayInList: true,
      allowFilter: false,
      dataType: "string",
      allowReportColumn: true,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Caller ID",
      accessor: "agentTalkedTo",
      displayInList: true,
      allowFilter: false,
      dataType: "string",
      allowReportColumn: true,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Hangup Cause",
      accessor: "hangupCause",
      displayInList: true,
      allowFilter: false,
      dataType: "string",
      allowReportColumn: true,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Start Stamp",
      accessor: "startTime",
      displayInList: true,
      allowFilter: true,
      dateTime: true,
      dataType: "date",
      allowReportColumn: true,
      allowReportFilter: true,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "End Stamp",
      accessor: "endTime",
      displayInList: true,
      allowFilter: true,
      dateTime: true,
      dataType: "date",
      allowReportColumn: true,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Talk Time",
      accessor: "agentTalkTime",
      displayInList: true,
      allowFilter: false,
      dataType: "string",
      sortDisable: true,
      allowReportColumn: true,
      Cell: ({ row,value }) => (
        <SessionData
          row={row}
          value={value}
        />
      ),
    },
    // {
    //   Header: "Answer Stamp",
    //   accessor: "answerTime",
    //   displayInList: false,
    //   allowFilter: false,
    //   dateTime: true,
    //   dataType: "date",
    //   allowReportColumn: true,
    //   Cell: ({ value }) => <DefaultCell value={value} />,
    // },
   
   
    {
      Header: "Duration",
      accessor: "duration",
      displayInList: true,
      allowFilter: false,
      dataType: "string",
      sortDisable: true,
      allowReportColumn: true,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Call Status",
      accessor: "status",
      displayInList: true,
      allowFilter: false,
      dataType: "string",
      allowReportColumn: true,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "MOS",
      accessor: "mos",
      displayInList: true,
      allowFilter: false,
      dataType: "string",
      allowReportColumn: true,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Recording File",
      accessor: "recordingFile",
      displayInList: true,
      allowFilter: false,
      dataType: "string",
      allowReportColumn: true,
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "Play",
      accessor: "",
      sortDisable: true,
      displayInList: true,
      downloadReports: false,
      Cell: ({ row }) => (
        <PAPlayAudio
          row={row}
          callerCallDataAnalysis={"callerCallDataAnalysis"}
        />
      ),
    },
    {
      Header: "Recording File",
      accessor: "",
      downloadReports: false,
      displayInList: true,
      allowFilter: false,
      dataType: "string",
      sortDisable: true,
      Cell: ({ row, value }) => (
        <CTLDownloadFile
          row={row}
          value={value}
          callerCallDataAnalysis={"callerCallDataAnalysis"}
        />
      ),
    },
  ];
};

export { getColumns, operationURLS };
